
import { gql } from '@apollo/client/core';

const CREATE_FACULTY = gql`
  mutation CreateFaculty($input: facultyInput!) {
    createFaculty(input: $input) {
      id
      faculty_name
      school_id
      type
      is_active
      createdAt
      updatedAt
    }
  }
`;

const CREATE_DEPARTMENT = gql`
  mutation CreateDepartment($input: departmentInput!) {
  createDepartment(input: $input) {
    id
    department_name
    type
    is_active
    createdAt
    updatedAt
  }
}
`;

const CREATE_PROGRAMME = gql`
  mutation CreateProgramme($input: programmeInput!) {
  createProgramme(input: $input) {
    id
    program_name
    prog_code
    department_id
    delivery_mode
             min_units_per_registration
             max_units_per_registration
    module_result_mode
    is_active
    createdAt
    updatedAt
  }
}
`;

const UPDATE_FACULTY = gql`
  mutation UpdateFaculty($id: ID!, $input: facultyInput!) {
    updateFaculty(id: $id, input: $input) {
      id
      faculty_name
      type
      is_active
      updatedAt
    }
  }
`;

const DELETE_FACULTY = gql`
  mutation DeleteFaculty($id: ID!) {
    deleteFaculty(id: $id) {
      success
      message
    }
  }
`;

const UPDATE_DEPARTMENT = gql`
  mutation UpdateDepartment($id: ID!, $input: DepartmentUpdateInput!) {
    updateDepartment(id: $id, input: $input) {
      id
      department_name
      faculty_id
      type
      is_active
      updatedAt
    }
  }
`;

const DELETE_DEPARTMENT = gql`
  mutation DeleteDepartment($id: ID!) {
    deleteDepartment(id: $id) {
      success
      message
    }
  }
`;

const UPDATE_PROGRAMME = gql`
  mutation UpdateProgramme($id: ID!, $input: programmeUpdateInput!) {
    updateProgramme(id: $id, input: $input) {
      id
      program_name
      prog_code
      department_id
      degree
      type
      duration
      min_units
      calculation_method
      delivery_mode
             min_units_per_registration
             max_units_per_registration
      module_result_mode
      graduation_criteria
      is_active
      updatedAt
    }
  }
`;

const DELETE_PROGRAMME = gql`
  mutation DeleteProgramme($id: ID!) {
    deleteProgramme(id: $id) {
      success
      message
    }
  }
`;

const CREATE_COURSE = gql`
  mutation CreateCourse($input: CourseCreateInput!) {
  createCourse(input: $input) {
    id
    course_title
    course_instance_id
    course_instance_year
    course_code
    is_active
    createdAt
    updatedAt
  }
}
`;

const CREATE_CURRICULUM = gql`
 mutation CreateCurriculum($input: createCurriculumInput!) {
  createCurriculum(input: $input)
}
`;

const UPDATE_CURRICULUM = gql`
  mutation UpdateCurriculum($id: ID!, $input: updateCurriculumInput) {
    updateCurriculum(id: $id, input: $input) {
      id
      course_id
      programme_id
      status
      semester
      course_registration_level
      programme_module_id
      school_id
      is_active
      course {
        id
        course_title
      }
      programme {
        id
        program_name
      }
      programmeModule {
        id
        name
        sequence
      }
    }
  }
`;

const DELETE_CURRICULUM = gql`
  mutation DeleteCurriculum($id: ID!) {
    deleteCurriculum(id: $id) {
      success
      message

    }
  }
`;

const UPDATE_COURSE = gql`
  mutation UpdateCourse($id: ID!, $input: CourseUpdateInput!) {
    updateCourse(id: $id, input: $input) {
      id
      course_instance_id
      course_instance_year
      course_code
      course_title
      unit
      school_id
      is_active
      createdAt
      updatedAt
    }
  }
`;

const DELETE_COURSE = gql`
  mutation DeleteCourse($id: ID!) {
    deleteCourse(id: $id) {
      success
      message

    }
  }
`;

const ADD_COURSE_TO_REG = gql`
  mutation AddCourseToReg($input: addCourseToRegInput!) {
    addCourseMutation(input: $input) {
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      coursesRegistered {
          programme_module_id
          module_name
          module_sequence
        id
        course_id
        course_status
        course {
          id
          course_code
          course_title
          unit
        }
      }
    }
  }
`;

const DROP_COURSE_FROM_REG = gql`
  mutation DropCourseFromReg($input: dropCourseFromRegInput!) {
      dropCourseMutation(input: $input) {
        id
        student_id
        academic_session
        semester
        registration_level
        programme_id
        coursesRegistered {
          programme_module_id
          module_name
          module_sequence
          id
          course_id
          course_status
          course {
            id
            course_code
            course_title
            unit
          }
        }
      }
    }
  `;

const UPDATE_COURSE_REGISTERED_FIELDS = gql`
  mutation UpdateCourseRegisteredFields($input: updateCourseRegisteredFieldsInput!) {
    updateCourseRegisteredFields(input: $input) {
      id
      student_course_registration_id
      course_id
      course_status
      accepted_for_programme_id
      is_transferred
      accepted_by
      accepted_at
      createdAt
      updatedAt
    }
  }
`;
  
const LECTURER_SUBMIT_COURSES = gql`
  mutation LecturerSubmitCoursesInSemester($input: lecturerSubmitCoursesInSemesterInput!) {
    lecturerSubmitCoursesInSemester(input: $input) {
      id
      
      course_id
      academic_calendar_id
      school_id
     
      
      course {
        id
          course_code
        course_title
        unit
      }
    }
  }
`;

const APPROVE_OR_DENY_COURSE = gql`
  mutation ApproveOrDenyCourse($input: approveOrDenyCourseInput!) {
    approveOrDenyCourse(input: $input) {
      id
      is_approved
      approved_at
      denied_at
      approved_by_id
      denied_by_id
    }
  }
`;

const ALLOCATE_COURSES = gql`
  mutation AllocateCoursesToLecturer($input: allocateCoursesToLecturerInSemesterByHODOrAdminInput!) {
    allocateCoursesToLecturerInSemesterByHODOrAdmin(input: $input) {
      id
      school_staff_id
      course_id
      academic_calendar_id
      is_approved
      approved_at
      denied_at
      created_at
      updated_at
      user {
        id
        name
      }
      course {
        id
        course_code
        course_title
        course_instance_id
        course_instance_year
        unit
      }
    }
  }
`;

const UPDATE_REGISTRATION_FIELDS = gql`
  mutation UpdateRegistrationFields($input: updateCourseRegistrationFieldsInput!) {
    updateRegistrationFields(input: $input) {
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      academic_calendar_id
      authorization_status
      approval_status
      rejection_reason
      programme {
        id
        program_name
      }
      coursesRegistered {
          programme_module_id
          module_name
          module_sequence
        id
        course_id
        course_status
        course {
          id
          course_code
          course_title
          unit
        }
      }
    }
  }
`;

const UPDATE_REGISTRATION_SCORES = gql`
  mutation UpdateRegistrationScores($courseScores: [CourseScoreInput!]!) {
    updateRegistrationScores(courseScores: $courseScores) {
      success
      message
      updated_count
      created_count
      
    }
  }
`;
    
const DEALLOCATE_COURSES = gql`
  mutation DeallocateCourseFromLecturer($input: allocateCoursesToLecturerInSemesterByHODOrAdminInput!) {
    deallocateCourseFromLecturer(input: $input) {
      id
      school_staff_id
      course_id
      academic_calendar_id
      is_approved
      approved_at
      denied_at
      created_at
      updated_at
      user {
        id
        name
      }
      course {
        id
        course_code
        course_title
      }
    }
  }
`;

const APPROVE_STUDENT_COURSE_REGISTRATION = gql`
  mutation ApproveStudentCourseRegistration($input: ApproveStudentRegistrationInput!) {
    approveStudentCourseRegistration(input: $input) {
      id
      approval_status
    }
  }
`;

const REJECT_STUDENT_COURSE_REGISTRATION = gql`
  mutation RejectStudentCourseRegistration($input: RejectStudentRegistrationInput!) {
    rejectStudentCourseRegistration(input: $input) {
      id
      approval_status
    }
  }
`;

const ENDORSE_COURSE_REGISTRATION_BY_HOD = gql`
  mutation EndorseCourseRegistrationByHOD($input: ApproveStudentRegistrationInput!) {
    endorseCourseRegistrationByHOD(input: $input) {
      id
      approval_status
    }
  }
`;

const OVERRIDE_COURSE_REGISTRATION_APPROVAL = gql`
  mutation OverrideCourseRegistrationApproval($input: OverrideRegistrationApprovalInput!) {
    overrideCourseRegistrationApproval(input: $input) {
      id
      approval_status
    }
  }
`;

const SENATE_APPROVE_STUDENT_REGISTRATION = gql`
  mutation SenateApproveStudentRegistration($input: ApproveStudentRegistrationInput!) {
    senateApproveStudentRegistration(input: $input) {
      id
      approval_status
      senate_approval_status
    }
  }
`;

export {
  CREATE_FACULTY,
  UPDATE_FACULTY,
  DELETE_FACULTY,
  CREATE_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  CREATE_PROGRAMME,
  UPDATE_PROGRAMME,
  DELETE_PROGRAMME,
  CREATE_COURSE,
  CREATE_CURRICULUM,
  UPDATE_CURRICULUM,
  DELETE_CURRICULUM,
  UPDATE_COURSE,
  DELETE_COURSE,
  CREATE_CAMPUS,
  UPDATE_CAMPUS,
  DELETE_CAMPUS,
  ADD_COURSE_TO_REG,
  DROP_COURSE_FROM_REG,
  UPDATE_COURSE_REGISTERED_FIELDS,
  UPDATE_REGISTRATION_FIELDS,
  UPDATE_REGISTRATION_SCORES,
  PUBLISH_RESULT,
  LECTURER_SUBMIT_COURSES,
  APPROVE_OR_DENY_COURSE,
  ALLOCATE_COURSES,
  DEALLOCATE_COURSES,
  APPROVE_STUDENT_COURSE_REGISTRATION,
  REJECT_STUDENT_COURSE_REGISTRATION,
  ENDORSE_COURSE_REGISTRATION_BY_HOD,
  OVERRIDE_COURSE_REGISTRATION_APPROVAL,
  SENATE_APPROVE_STUDENT_REGISTRATION,
  ADMIN_SUBMIT_COURSE_REGISTRATION,
};

const CREATE_CAMPUS = gql`
  mutation CreateCampus($input: campusInput!) {
    createCampus(input: $input) {
      id
      name
      school_id
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_CAMPUS = gql`
  mutation UpdateCampus($id: Int!, $input: campusInput!) {
    updateCampus(id: $id, input: $input) {
      id
      name
      updatedAt
    }
  }
`;

const DELETE_CAMPUS = gql`
  mutation DeleteCampus($id: Int!) {
    deleteCampus(id: $id) {
       success
       message
    }
  }
`;

const PUBLISH_RESULT = gql`
mutation PublishResult($studentId: ID!, $calendarId: ID!) {
    publishStudentResult(student_id: $studentId, academic_calendar_id: $calendarId) {
        id
        status
        created_at
    }
}
`;

const ADMIN_SUBMIT_COURSE_REGISTRATION = gql`
  mutation AdminSubmitCourseRegistration($input: adminCourseRegistrationInput!) {
    adminSubmitCourseRegistration(input: $input) {
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      academic_calendar_id
    
      approval_status
      programme {
        id
        program_name
      }
      student {
        id
        first_name
        surname
        matric_no
      }
      coursesRegistered {
          programme_module_id
          module_name
          module_sequence
        id
        course_id
        course_status
        course {
          id
          course_code
          course_title
          unit
        }
      }
    }
  }
`;

const STUDENT_ALLOCATION_RESULT_FRAGMENT = gql`
  fragment StudentAllocationResultFields on StudentAllocationResult {
    success
    message
    total_allocated
    unallocated_count
    allocations {
      course_lecturer_id
      lecturer_name
      school_staff_id
      allocated_count
      students {
        id
        course_id
        studentCourseRegistration {
          id
          student_id
          registration_level
          programme {
            id
            program_name
            prog_code
          }
          student {
            id
            first_name
            surname
            matric_no
          }
        }
      }
    }
  }
`;

export const ALLOCATE_STUDENTS_RANDOMLY = gql`
  ${STUDENT_ALLOCATION_RESULT_FRAGMENT}
  mutation AllocateStudentsToLecturersRandomly(
    $course_id: ID!
    $course_lecturer_ids: [ID!]!
    $group_by: AllocationGroupBy
    $academic_calendar_id: ID
  ) {
    allocateStudentsToLecturersRandomly(
      course_id: $course_id
      course_lecturer_ids: $course_lecturer_ids
      group_by: $group_by
      academic_calendar_id: $academic_calendar_id
    ) {
      ...StudentAllocationResultFields
    }
  }
`;

export const ALLOCATE_STUDENTS_MANUALLY = gql`
  ${STUDENT_ALLOCATION_RESULT_FRAGMENT}
  mutation AllocateStudentsToLecturerManually(
    $course_lecturer_id: ID!
    $course_registered_ids: [ID!]!
  ) {
    allocateStudentsToLecturerManually(
      course_lecturer_id: $course_lecturer_id
      course_registered_ids: $course_registered_ids
    ) {
      ...StudentAllocationResultFields
    }
  }
`;

export const REALLOCATE_STUDENTS = gql`
  ${STUDENT_ALLOCATION_RESULT_FRAGMENT}
  mutation ReallocateStudents(
    $course_registered_ids: [ID!]!
    $target_course_lecturer_id: ID!
  ) {
    reallocateStudents(
      course_registered_ids: $course_registered_ids
      target_course_lecturer_id: $target_course_lecturer_id
    ) {
      ...StudentAllocationResultFields
    }
  }
`;

export const CLEAR_STUDENT_LECTURER_ALLOCATIONS = gql`
  mutation ClearStudentLecturerAllocations($course_id: ID!, $academic_calendar_id: ID) {
    clearStudentLecturerAllocations(course_id: $course_id, academic_calendar_id: $academic_calendar_id) {
      success
      message
    }
  }
`;

// Omit both ids for the school-wide row. subscribed:false WITHOUT ids removes
// every row the user holds; with an id it removes only that scoped row.
export const SET_PENDING_APPROVAL_NOTIFICATION_SUBSCRIPTION = gql`
  mutation SetPendingApprovalNotificationPreference($subscribed: Boolean!, $departmentId: ID, $programmeId: ID) {
    setPendingApprovalNotificationSubscription(subscribed: $subscribed, departmentId: $departmentId, programmeId: $programmeId) {
      topic
      subscribed
      scopes {
        id
        schoolWide
        departmentId
        departmentName
        programmeId
        programmeName
      }
    }
  }
`;

export const BULK_COURSE_REGISTRATION_ACTION = gql`
  mutation BulkCourseRegistrationAction($input: BulkCourseRegistrationActionInput!) {
    bulkCourseRegistrationAction(input: $input) {
      success
      message
      affected_count
      skipped_count
    }
  }
`;

export const BULK_SWAP_COURSE = gql`
  mutation BulkSwapCourse(
    $old_course_id: ID!
    $new_course_id: ID!
    $programme_id: ID!
    $academic_calendar_id: ID
  ) {
    bulkSwapCourse(
      old_course_id: $old_course_id
      new_course_id: $new_course_id
      programme_id: $programme_id
      academic_calendar_id: $academic_calendar_id
    ) {
      success
      message
    }
  }
`;

export const BULK_UPDATE_REGISTRATION_LEVEL = gql`
  mutation BulkUpdateRegistrationLevel($registration_ids: [ID!]!, $registration_level: String, $programme_id: ID) {
    bulkUpdateRegistrationLevel(registration_ids: $registration_ids, registration_level: $registration_level, programme_id: $programme_id) {
      success
      message
      affected_count
      skipped_count
    }
  }
`;

export const CREATE_PROGRAMME_MODULE = gql`
  mutation CreateProgrammeModule($input: createProgrammeModuleInput!) {
    createProgrammeModule(input: $input) {
      id
      programme_id
      session_id
      academic_calendar_id
      name
      sequence
      registration_fee
      retake_fee
      registration_fee_item_template_id
      retake_fee_item_template_id
      min_units_per_registration
      max_units_per_registration
      started_at
      ended_at
      is_active
      is_open
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PROGRAMME_MODULE = gql`
  mutation UpdateProgrammeModule($id: ID!, $input: updateProgrammeModuleInput!) {
    updateProgrammeModule(id: $id, input: $input) {
      id
      programme_id
      session_id
      academic_calendar_id
      name
      sequence
      registration_fee
      retake_fee
      registration_fee_item_template_id
      retake_fee_item_template_id
      min_units_per_registration
      max_units_per_registration
      started_at
      ended_at
      is_active
      is_open
      updatedAt
    }
  }
`;

export const TOGGLE_PROGRAMME_MODULE = gql`
  mutation ToggleProgrammeModule($id: ID!, $is_active: Boolean!) {
    toggleProgrammeModule(id: $id, is_active: $is_active) {
      id
      is_active
      is_open
    }
  }
`;

export const DELETE_PROGRAMME_MODULE = gql`
  mutation DeleteProgrammeModule($id: ID!) {
    deleteProgrammeModule(id: $id) {
      success
      message
    }
  }
`;

export const SET_COURSE_PREREQUISITES = gql`
  mutation SetCoursePrerequisites($course_id: ID!, $prerequisite_course_ids: [ID!]!) {
    setCoursePrerequisites(course_id: $course_id, prerequisite_course_ids: $prerequisite_course_ids) {
      id
      course_id
      prerequisite_course_id
      prerequisiteCourse {
        id
        course_code
        course_title
        unit
      }
    }
  }
`;

export const REMOVE_COURSE_PREREQUISITE = gql`
  mutation RemoveCoursePrerequisite($id: ID!) {
    removeCoursePrerequisite(id: $id) {
      success
      message
    }
  }
`;
